import * as React from "react";
import type { SVGProps } from "react";
const SvgUsers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 21a1 1 0 1 0 2 0zm-3-6v-1zm-8 0v-1zm-4 4H0zm-1 2a1 1 0 1 0 2 0zm22 0a1 1 0 1 0 2 0zm1-2h1zm-2.75-4.838a1 1 0 1 0-.5 1.936zm-4.002-12a1 1 0 1 0-.496 1.937zm2.76 4.843h1zm-3.256 2.906a1 1 0 1 0 .496 1.938zM18 21v-2h-2v2zm0-2a5 5 0 0 0-1.465-3.536l-1.414 1.415A3 3 0 0 1 16 19zm-1.465-3.536A5 5 0 0 0 13 14v2a3 3 0 0 1 2.121.879zM13 14H5v2h8zm-8 0a5 5 0 0 0-3.536 1.464L2.88 16.88A3 3 0 0 1 5 16zm-3.536 1.464A5 5 0 0 0 0 19h2a3 3 0 0 1 .879-2.121zM0 19v2h2v-2zM12 7a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3H4a5 5 0 0 0 5 5zM6 7a3 3 0 0 1 3-3V2a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zm15 17v-2h-2v2zm0-2a5 5 0 0 0-1.048-3.06l-1.581 1.225A3 3 0 0 1 22 19.001zm-1.048-3.06a5 5 0 0 0-2.702-1.778l-.5 1.936a3 3 0 0 1 1.621 1.067zm-7.2-11.841a3 3 0 0 1 1.626 1.066l1.58-1.226a5 5 0 0 0-2.71-1.778zm1.626 1.066a3 3 0 0 1 .63 1.84h2a5 5 0 0 0-1.05-3.066zm.63 1.84a3 3 0 0 1-.63 1.84l1.58 1.226a5 5 0 0 0 1.05-3.066zm-.63 1.84a3 3 0 0 1-1.626 1.066l.496 1.938a5 5 0 0 0 2.71-1.778z"
    />
  </svg>
);
export default SvgUsers;
